import {
  AccessAlarm,
  CrisisAlert,
  DeviceHub,
  NotificationsActive,
  ShutterSpeed,
} from "@mui/icons-material";
import {
  Card,
  CardContent,
  CardHeader,  
  Divider,
  Paper,
  Tab,
  Tabs,
} from "@mui/material";

import React, { useState } from "react";
import Alarms from "./Alarms";
import { blue } from "@mui/material/colors";
import Events from "./Events";
import Speed from "./Speed";
import Community from "./Community";
import RiskArea from "./RiskArea";

function Index() {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Paper
      elevation={0}
      variant="outlined"
      sx={{ flexGrow: 1, overflowY: "hidden", borderRadius: 0, bgcolor: blue[50] }}
    >
      <Card
        elevation={0}
        variant="outlined"
        sx={{ border: 0, borderRadius: 0,minWidth:800 }}
        className="animate__animated animate__rotateInDownLeft"
      >
        <CardHeader
          sx={{ bgcolor: blue[100] }}
          title={"Reports"}
          titleTypographyProps={{ variant: "h5", fontWeight: 700 }}
        />
        <Divider />
        <CardContent sx={{ bgcolor: blue[50] }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="icon tabs example"
            sx={{ mb: 1 }}
          >
            <Tab icon={<NotificationsActive />} label="การแจ้งเตือน" />
            <Tab icon={<AccessAlarm />} label="เหตุการณ์" />
            <Tab icon={<ShutterSpeed />} label="ความเร็ว" />
            <Tab icon={<DeviceHub />} label="เขตชุมชน" />
            <Tab icon={<CrisisAlert />} label="พื้นที่เสี่ยง" />
          </Tabs>
          {value === 0 && <Alarms />}
          {value === 1 && <Events />}
          {value === 2 && <Speed />}
          {value === 3 && <Community />}
          {value === 4 && <RiskArea />}
        </CardContent>
      </Card>
    </Paper>
  );
}

export default Index;
